import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center p-5 py-10 pt-7 space-y-10" }
const _hoisted_2 = { class: "flex flex-col space-y-6 items-center" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"flex text-brand-lime space-x-5 pt-4\"><svg class=\"w-8 fill-current\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><path d=\"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4L127 384.5zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z\"></path></svg><svg class=\"w-8 fill-current\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path d=\"M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z\"></path></svg></div><div class=\"flex flex-col w-full items-center space-y-1 px-2\"><div class=\"flex text-white text-2xl font-medium text-center\">Feature Unavailable</div><div class=\"text-brand-light-gray text-lg text-center leading-tight\">This feature is not available on the Progressive Web App (PWA).<br><br>To access all app features ensure you&#39;re using the latest version of the app that&#39;s installable via the Apple and Google Play stores. </div></div>", 2)
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col justify-center items-center px-2 pt-5"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray text-xs font-medium mb-2" }, "What's new in this release", -1)
const _hoisted_7 = { class: "text-sm text-white space-y-3 text-center" }

import {onMounted, Ref, ref} from 'vue';
import InAppSubscription from "@/components/InAppSubscription.vue";
import {modalController} from "@ionic/vue";
import {useAppUpdate} from "@/composables/useAppUpdate";
import ApiService from "@/services/api/apiService";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppStoreAppRequired',
  props: {
  appVersion: {
    type: String,
    default: ''
  }
},
  setup(__props) {


const loading = ref(true)

const props = __props

const whatsNew: Ref<string[]> = ref([])


onMounted(async () => {
  whatsNew.value = await ApiService.ChangeLog().get(props.appVersion)
  loading.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (whatsNew.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(whatsNew.value, (change, changeKey) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: changeKey,
                  class: "leading-tight"
                }, _toDisplayString(change), 1))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})